<template class="pt-0">
  <div
    v-if="state.caseDetails && !closedCasesCondition"
    :class="appendSehattyClass('donate px-3 px-md-5 mb-5 w-100')"
  >
    <div class="donate__container d-flex justify-content-center w-100 mb-3">
      <div class="col-md-6 donate__card donate-back-button-wrapper d-flex justify-content-start align-items-end">
         <Button
           class="p-button-outlined donate-back-button"
           @click="goBack"
         >
          <i class="pi pi-arrow-right mx-2"></i>
          <span>العودة</span>
         </Button>
      </div>
      <div class="col-md-6 donate__card donate-button-spacer"></div>
    </div>
    <div class="donate__container d-flex justify-content-center w-100">
      <DonateCardDetails :payload="state.caseDetails" type="case" :sehatty="state.isSehattyPage"/>
      <div  :class="appendSehattyClass('donate__card donate__form col-md-6 section bg-white')">
        <h2
          :class="appendSehattyClass('title fw-bold text-center donate__heading')"
          data-cy="donate-case-card-header"
        >
          المبلغ المراد التبرع به
        </h2>
        <div class="tags d-flex justify-content-evenly mb-5">
          <div
            :class="{
              'selected-button': state.donationModel.donation_amount === presetAmounts[0],
              'p-disabled': state.disablePaymentFields,
              'sehatty': state.isSehattyPage
            }"
            class="tag mb-3 mb-lg-0 fw-semibold d-flex align-items-center justify-content-center"
            @click="setDonationAmount(presetAmounts[0])"
            data-cy="donate-10-sar"
          >
            {{ presetAmounts[0] }} <div class="sar-icon me-1" />
          </div>
          <div
            :class="{
              'selected-button': state.donationModel.donation_amount === presetAmounts[1],
              'p-disabled': state.disablePaymentFields,
              'sehatty': state.isSehattyPage
            }"
            class="tag mb-3 mb-lg-0 fw-semibold d-flex align-items-center justify-content-center"
            @click="setDonationAmount(presetAmounts[1])"
            data-cy="donate-50-sar"
          >
            {{ presetAmounts[1] }} <div class="sar-icon me-1" />
          </div>
          <div
            :class="{
              'selected-button': state.donationModel.donation_amount === presetAmounts[2],
              'p-disabled': state.disablePaymentFields,
              'sehatty': state.isSehattyPage
            }"
            class="tag mb-3 mb-lg-0 fw-semibold d-flex align-items-center justify-content-center "
            @click="setDonationAmount(presetAmounts[2])"
            data-cy="donate-100-sar"
          >
            {{ presetAmounts[2] }} <div class="sar-icon me-1" />
          </div>
          <div
            :class="{
              'selected-button':
                state.donationModel.donation_amount ===
                state.caseDetails.required_amount -
                  state.caseDetails.collected_amount,
              'p-disabled': state.disablePaymentFields,
              'sehatty': state.isSehattyPage
            }"
            class="tag mb-3 mb-lg-0 fw-semibold d-flex align-items-center justify-content-center "
            data-cy="donate-remaining-amount"
            @click="
              state.donationModel.donation_amount =
                state.caseDetails.required_amount -
                state.caseDetails.collected_amount
            "
          >
            التبرع بالمبلغ المتبقي
          </div>
        </div>
        <div class="w-100 mb-1">
          <BaseInputNumber
            v-model="state.donationModel.donation_amount"
            :disabled="state.disablePaymentFields"
            :min="1"
            :max="
              state.caseDetails.required_amount -
              state.caseDetails.collected_amount
            "
            :placeholder="`أدخل مبلغ التبرع`"
            :class="{
              'p-invalid': invalidAmount,
            }"
            id="donation-amount"
            inputId="donation-amount"
            data-cy="donation-amount"
          />
        </div>
        <div  :class="[{ 'sehatty': state.isSehattyPage},{'text-danger' : invalidAmount }, 'mb-4 donation-disclaimer']">
          أعلى قيمة يمكنك التبرع بها {{ maximumDonationAmount }} وأقل قيمة يمكنك
          التبرع بها {{ configMinimumAmount.toFixed(2) }}
        </div>
        <BaseInputNumber
          :placeholder="'ليصلك اثر تبرعك أدخل رقم جوالك'"
          v-model="state.donationModel.doner_mobile"
          :disabled="state.disablePaymentFields"
          :class="{
            'p-invalid':
              state.donationModel.doner_mobile &&
              !isValidMobileNumber(state.donationModel.doner_mobile),
          }"
          id="doner-mobile"
          :maxLength="10"
          :phoneNumber="true"
          v-if="!$store.getters.isAuthenticated"
        />
        <div class="mb-4 d-flex align-items-center justify-content-between" v-if="!state.isMajorDonor">
          <div>
            <Checkbox
              v-model="state.donationModel.on_behalf_donation"
              :binary="true"
              inputId="on_behalf_donation"
              data-cy="on-behalf-donation-checkbox"
              id="on_behalf_donation"
              :class="{'sehatty': state.isSehattyPage}"
              :disabled="!isAuthenticated || state.disablePaymentFields"
            />
            <label for="on_behalf_donation" class="mx-2"
                  :class="{ 'color-secondary': state.disablePaymentFields }"
                  v-if="isAuthenticated">تبرع عن من تحب</label>
            <label v-else class='mx-2 color-secondary'>
              <RouterLink to="/sign-in" class="color-primary mx-1">سجل الدخول</RouterLink>
              لتتبرع عن من تحب
            </label> 
          </div>
          <template v-if="state.donationModel.on_behalf_donation">
            <button
              :class="appendSehattyClass('p-button message-preview p-button-primary p-button-rounded p-button-outlined d-flex flex-column p-1 mt-2 border-0')"
              style="text-decoration: none"
              @click="openPreviewSMS"
            >
              <i class="pi pi-eye fs-3"></i>
              <div class="px-2">معاينة الرسالة</div>
            </button>
          </template>
        </div>
        <div v-if="state.donationModel.on_behalf_donation">
          <div class="w-100 mb-4">
            <InputText
              inputId="doner-name"
              data-cy="donor-name"
              id="doner-name"
              placeholder="اسم المتبرع"
              v-model="state.donationModel.on_behalf_donor_name"
               :class="[
                 appendSehattyClass('w-100'),
                 {
                   'p-invalid':
                     state.donationModel.on_behalf_donor_name &&
                     state.donationModel.on_behalf_donor_name.length > 20,
                 },
               ]"
               :disabled="state.disablePaymentFields"
            />
            <small
              class="p-error d-block mt-2"
              v-if="
                state.donationModel.on_behalf_donor_name &&
                state.donationModel.on_behalf_donor_name.length > 20
              "
            >
              الحد الأقصى 20 حرف
            </small>
          </div>
          <div
            class="w-100 mb-4"
            v-if="state.donationModel.gifted_to === 'أخرى'"
          >
            <InputText
              inputId="giftedToText"
              id="giftedToText"
              data-cy="gifted-to-text"
              placeholder="إهداء إلى"
              v-model="state.donationModel.gifted_to_text"
              class="w-100"
              :class="{
                'p-invalid':
                  state.isSubmitted &&
                  state.donationModel.gifted_to === 'أخرى' &&
                  !state.donationModel.gifted_to_text,
              }"
            />
          </div>
          <div class="w-100 mb-4">
            <BaseInputNumber
              :placeholder="'جوال المهدى له'"
              v-model="state.donationModel.gifted_mobile_number"
              :class="{
                'p-invalid':
                  (state.isSubmitted &&
                    state.donationModel.on_behalf_donation &&
                    !state.donationModel.gifted_mobile_number) ||
                  (state.donationModel.gifted_mobile_number &&
                    !isValidMobileNumber(
                      state.donationModel.gifted_mobile_number
                    )),
              }"
              id="mobile-number"
              data-cy="gifted-mobile-number"
              :maxLength="10"
              :phoneNumber="true"
              :disabled="state.disablePaymentFields"
            />
          </div>
          <div
            class="w-100 mb-4"
            v-if="state.donationModel.donor_relation === 'أخرى'"
          >
            <InputText
              inputId="donor_relation_Text"
              id="donor_relation_Text"
              data-cy="donor-relation-text"
              placeholder="توقيع المٌهدي"
              v-model="state.donationModel.donor_relation_text"
              class="w-100"
              :class="{
                'p-invalid':
                  state.isSubmitted &&
                  state.donationModel.donor_relation === 'أخرى' &&
                  !state.donationModel.donor_relation_text,
              }"
            />
          </div>
        </div>
        <div v-if="!state.isMajorDonor" :class="appendSehattyClass('mb-2 color-secondary ')">وسيلة الدفع</div>
        <div
          class="payment-methods d-flex align-items-center justify-content-center mb-3"
          v-if="!state.isMajorDonor"
        >
          <div
            class="item d-flex align-items-center justify-content-center"
            @click="state.cardType = 'credit_card'"
            :class="{ selected: state.cardType === 'credit_card' , 'sehatty': state.isSehattyPage}"
          >
            <img
              class="payment-radio__image payment-radio__image--visa"
              loading="lazy"
              :src="`${staticUrl}/static/images/card-pay-payment.png`"
              alt=""
              data-cy="pay-by-credit-card"
            />
          </div>
          <div>
            <div
              class="apple-pay item d-flex align-items-center justify-content-center"
              @click="applePayDonation"
              :class="{
                selected: state.cardType === 'applepay',
                'p-disabled': disableSubmit,
              }"
            >
              <img
                data-cy="pay-by-apple-pay"
                loading="lazy"
                :src="`${staticUrl}/static/images/apple-pay-logo.png`"
                alt="apple-pay"
              />
            </div>
          </div>
        </div>
        <div v-if="!state.isMajorDonor" class="row my-5">
          <DonationProvacyPolicy pre-link-text="بإتمام التبرع أنت موافق على" />
          <BaseSpinner v-if="state.showApplepaySpinner" />
          <Button
             :class="appendSehattyClass('donate__button p-button-rounded p-button p-button-primary mt-2 mx-auto justify-content-center')"
            @click.stop="donate"
            data-cy="donate-button"
            :disabled="disableSubmit"
            v-if="state.cardType === 'credit_card'"
          >
            <i v-if="state.loading" class="pi pi-spin pi-spinner ms-2"></i>
            <span>تبرع الآن</span>
          </Button>
          <div
            :class="['form-cont', { 'd-none': state.cardType !== 'applepay' }]"
            v-if="
              state.donationModel.donation_amount && state.isHyperpayInjected
            "
          >
            <form
              :action="state.redirectURI"
              class="paymentWidgets"
              :data-brands="'APPLEPAY'"
            ></form>
          </div>
        </div>
        <div v-else class="row my-5">
          <Button
            class='donate__button p-button-rounded p-button p-button-primary mt-2 mx-auto justify-content-center'
            @click.stop="transfer"
            data-cy="donate-button"
            :disabled="disableSubmit"
          >
            <i v-if="state.loading" class="pi pi-spin pi-spinner ms-2"></i>
            <i v-else class="pi pi-wallet ms-2"></i>
            <span> الدفع عن طريق المحفظة</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
  <CompletedDonation v-else-if="closedCasesCondition" donation_type="case" :speciality_id="state.caseDetails.speciality_id" />

  <PreviewSMSDialog
    :showModal="state.showPreviewSMS"
    @close="closePreviewSMS"
    :previewImageLink="state.previewImageLink"
  />

  <DonationSuccessDialog
    :showModal="state.showDonationSuccessModal"
    :data="state.successDonationData"
    :heading="state.paymentSuccessHeading"
    :message="state.paymentSuccessMessage"
    :donationType="state.donationType"
    v-if="state.showDonationSuccessModal"
    @close="close"
    :sehatty="state.isSehattyPage"
  />

  <DonationFailureDialog
    :showModal="state.showDonationFailureModal"
    :heading="state.paymentFailureHeading"
    :message="state.paymentFailureMessage"
    v-if="state.showDonationFailureModal"
    @close="state.showDonationFailureModal = false"
    :sehatty="state.isSehattyPage"
  />
  <DonationInProgressDialog
    :showModal="state.showInProgressModal"
    :data="state.progressDonationData"
    :status="state.progressStatus"
    :donationType="state.donationType"
    v-if="state.showInProgressModal"
    @close="state.showInProgressModal = false"
  />
  <MajorDonorFailure
    :showModal="state.showMajorDonorFailureModal"
    :data="state.majorDonorFailureData"
    @close="state.showMajorDonorFailureModal = false"
  />
</template>

<script setup>
import { reactive, computed, inject, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useHead } from "@vueuse/head";
import { DONATION_AMOUNTS_CONFIG } from "@/config/donationAmountsConfig";

import DonationService from "@/services/donation.service";
import MajorDonorsService from "@/services/major-donors.service";
import MajorDonorFailure from "@/components/major-donors/DonationFailureDialog.vue";
import { getBrowserEngine } from "@/hooks/useBrowserEnvironmet";
import { getLocalValue, setLocalValue } from "@/hooks/useLocalStorage";
import { DONATION_TYPE } from "@/services/enum.service";
import MediaService from "@/services/media.service";
import { useDonationValidation } from "@/composables/useDonationValidation";
import { appendSehattyClass } from "@/helpers/helpers";
import { isDonationClosedError } from "@/helpers/donationClosed";
import { extractPaymentFailureMessage } from "@/helpers/paymentStatusError";
// Components
import DonateCardDetails from "@/components/donate/DonateCardDetails";
import BaseSpinner from "@/components/layout/BaseSpinner";
import CompletedDonation from "@/components/donate/CompletedDonation";
import DonationFailureDialog from "@/components/donate/DonationFailureDialog";
import DonationSuccessDialog from "@/components/donate/DonationSuccessDialog";
import DonationInProgressDialog from "@/components/donate/DonationInProgressDialog";
import DonationProvacyPolicy from "@/components/layout/DonationPrivacyPolicy";
import PreviewSMSDialog from "@/components/donate/PreviewSMSDialog";
import { useStore } from "vuex";
import JwtUtilService from "@/services/jwt.util.service";
const route = useRoute();
const router = useRouter();
const staticUrl = inject("staticUrl");
const store = useStore();

const { isValidMobileNumber, validateOnBehalfDonation } =
  useDonationValidation();

const state = reactive({
  caseId: route.params.case_id,
  caseDetails: null,
  donationModel: {
    donation_amount: null,
    doner_mobile: "",
    on_behalf_donor_name: "",
    gifted_to: "",
    gifted_to_text: "",
    donor_relation: "",
    donor_relation_text: "",
    gifted_mobile_number: "",
    on_behalf_donation: false,
  },
  checkoutId: "",
  browserName: getBrowserEngine(),
  cardType: "credit_card",
  redirectURI:
    process.env.VUE_APP_FE_URL +
    `/donate-case/${route.params.case_id}` +
    (route.query.close ? `?close=${route.query.close}` : ""),
  isAmbassador: false,
  referenceId: route.query.reference_id || null,
  isSubmitted: false,
  paymentSuccessHeading: "",
  paymentSuccessMessage: "",
  paymentFailureHeading: "",
  paymentFailureMessage: "",
  showDonationFailureModal: false,
  isHyperpayInjected: false,
  showApplepaySpinner: false,
  showDonationSuccessModal: false,
  showInProgressModal: false,
  successDonationData: {},
  progressDonationData: {},
  progressStatus: 202,
  donationType: DONATION_TYPE.CASE,
  resourcePath: "",
  paymentTransactionId: 0,
  disablePaymentFields: false,
  loading: false,
  showPreviewSMS: false,
  previewImageLink: "",
  integrity: "",
  isSehattyPage: store.getters.isSehattyPage,
  isMajorDonor: JwtUtilService.getClientID()?.includes("major-donor"),
  showMajorDonorFailureModal: false,
  majorDonorFailureData: {},
  // Set when the backend refuses the checkout because the case can no longer
  // receive donations, so we render the "case complete" screen instead of the
  // failure pop-up.
  donationClosed: false,
});

const caseConfig = DONATION_AMOUNTS_CONFIG.case;
const presetAmounts = caseConfig.presetAmounts;
const configMinimumAmount = caseConfig.minimumAmount;

const openPreviewSMS = async () => {
  const { data: { result } = {} } = await MediaService.getSmsPreview();
  state.previewImageLink = result;
  state.showPreviewSMS = true;
};

const closePreviewSMS = () => {
  state.showPreviewSMS = false;
};

const goBack = () => {
  router.go(-1);
};

const getCaseInfo = async () => {
  if (state.caseId === undefined) return;

  try {
    const {
      data: { result },
    } = await DonationService.getCaseDetails(state.caseId, state.referenceId);

    state.caseDetails = result;
    if(closedCasesCondition.value && state.isSehattyPage){
      router.push("/sehatty");
    }
    useHead({
      meta: [
        {
          name: "og:description",
          content: state.caseDetails.story,
        },
        {
          name: "og:image",
          content:
            state.caseDetails.urls.case_image[0] ||
            state.caseDetails.urls.charity_image,
        },
        {
          name: "twitter:image",
          content: state.caseDetails.urls.case_image[0],
        },
        {
          name: "twitter:description",
          content: state.caseDetails.story,
        },
      ],
    });

    state.caseDetails.remainingAmount =
      state.caseDetails.required_amount - state.caseDetails.collected_amount;
    state.caseDetails.amountPercentage = Math.floor(
      (state.caseDetails.collected_amount / state.caseDetails.required_amount) *
        100
    );

    if (route.query.close === "true") {
      state.donationModel.donation_amount =
        state.caseDetails.required_amount - state.caseDetails.collected_amount;
    }

  } catch (error) {
    console.error("Error fetching case details:", error);
  }
};

// The case may have completed while the donor was filling in the form. In that
// case send them to the "case already complete" screen rather than the generic
// payment failure pop-up.
const handleClosedDonation = () => {
  state.donationClosed = true;
  state.showDonationFailureModal = false;
  state.disablePaymentFields = true;

  if (state.isSehattyPage) {
    router.push("/sehatty");
    return;
  }

  // Refresh so the completed screen and its recommendations reflect the case's
  // current state.
  getCaseInfo();
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const donate = async () => {
  state.loading = true;
  state.isSubmitted = true;

  if (
    state.donationModel.on_behalf_donation &&
    !validateOnBehalfDonation(state.donationModel)
  ) {
    state.loading = false;
    return;
  }

  try {
    if (!state.isAmbassador) {
      const checkoutPayload = {
        amount: state.donationModel.donation_amount,
        card_type: state.cardType,
        object_id: state.caseDetails.id,
        object_type: "case",
        gifted_mobile_number: state.donationModel.on_behalf_donation
          ? state.donationModel.gifted_mobile_number
          : null,
        target: state.caseDetails.required_amount,
        to_wallet: state.caseDetails.wallet,
        on_behalf_donor_name: state.donationModel.on_behalf_donor_name || null,
        link_of_the_donated_on_object: state.redirectURI,
        donor_mobile_number: getLocalValue("donor_mobile_number") || state.donationModel.doner_mobile || null,
        on_behalf_donation: state.donationModel.on_behalf_donation,
      };
      route.query.reference_id && (checkoutPayload.reference_id = route.query.reference_id);
      if(state.isSehattyPage){
        checkoutPayload.is_sehhaty = true;
      }
      const {
        data: {
          result: { checkout_id, integrity },
        },
      } = await DonationService.getPaymentId(checkoutPayload);
      setLocalValue("scriptIntegrity", integrity);
      state.integrity = integrity;
      state.checkoutId = checkout_id;
      localStorage.setItem(
        "donationModel",
        JSON.stringify(state.donationModel)
      );
      localStorage.setItem("wallet", JSON.stringify(state.caseDetails.wallet));
      injectCheckoutLibrary();
    } else {
      const postBody = {
        amount: state.donationModel.donation_amount,
        card_type: state.cardType,
        object_id: state.caseDetails.id,
        object_type: "case",
        on_behalf_donor_name: state.donationModel.on_behalf_donor_name || null,
        gifted_mobile_number: state.donationModel.on_behalf_donation
          ? state.donationModel.gifted_mobile_number
          : null,
        target: state.caseDetails.required_amount,
        to_wallet: state.caseDetails.wallet,
        link_of_the_donated_on_object: state.redirectURI,
        donor_mobile_number: getLocalValue("donor_mobile_number") || state.donationModel.doner_mobile || null,
        on_behalf_donation: state.donationModel.on_behalf_donation,
      };

      const {
        data: {
          result: { checkout_id },
        },
      } = await DonationService.getAmbassadorPaymentId(
        postBody,
        state.referenceId
      );
      state.checkoutId = checkout_id;
      localStorage.setItem(
        "donationModel",
        JSON.stringify(state.donationModel)
      );
      localStorage.setItem("wallet", JSON.stringify(state.caseDetails.wallet));
      injectCheckoutLibrary();
    }
  } catch (error) {
    if (isDonationClosedError(error)) {
      handleClosedDonation();
      return;
    }
    if (error?.response?.data?.errors?.length > 0) {
      state.paymentFailureMessage = error.response.data.errors[0];
    } else if (error?.response?.data?.message) {
      state.paymentFailureMessage = error.response.data.message;
    } else if (error?.message) {
      state.paymentFailureMessage = error.message;
    }
    state.showDonationFailureModal = true;
  } finally {
    state.loading = false;
  }
};

const applePayDonation = async () => {
  state.isSubmitted = true;

  if (
    !state.donationModel.donation_amount ||
    invalidOnBehalfName.value ||
    (state.donationModel.on_behalf_donation &&
      !validateOnBehalfDonation(state.donationModel))
  ) {
    return;
  }

  state.disablePaymentFields = true;

  state.cardType = "applepay";
  if (state.isHyperpayInjected) return;

  state.showApplepaySpinner = true;

  try {
    const checkoutPayload = {
      amount: state.donationModel.donation_amount,
      card_type: state.cardType,
      object_id: state.caseDetails.id,
      object_type: "case",
      gifted_mobile_number: state.donationModel.on_behalf_donation
        ? state.donationModel.gifted_mobile_number
        : state.donationModel.doner_mobile,
      target: state.caseDetails.required_amount,
      to_wallet: state.caseDetails.wallet,
      on_behalf_donor_name: state.donationModel.on_behalf_donor_name || null,
      link_of_the_donated_on_object: state.redirectURI,
      donor_mobile_number: getLocalValue("donor_mobile_number") || state.donationModel.doner_mobile || null,
      on_behalf_donation: state.donationModel.on_behalf_donation,
      gifted_mobile_number: state.donationModel.on_behalf_donation
        ? state.donationModel.gifted_mobile_number
        : null,
    };
    route.query.reference_id && (checkoutPayload.reference_id = route.query.reference_id);
    if(state.isSehattyPage){
      checkoutPayload.is_sehhaty = true;
    }
    const {
      data: {
        result: { checkout_id, integrity },
      },
    } = await DonationService.getPaymentId(checkoutPayload, state.referenceId);
    setLocalValue("scriptIntegrity", integrity);
    state.integrity = integrity;
    state.checkoutId = checkout_id;
    localStorage.setItem("donationModel", JSON.stringify(state.donationModel));
    localStorage.setItem("wallet", JSON.stringify(state.caseDetails.wallet));
    injectCheckoutLibrary();
  } catch (error) {
    state.showApplepaySpinner = false;
    if (isDonationClosedError(error)) {
      handleClosedDonation();
      return;
    }
    if (error?.response?.data?.errors?.length > 0) {
      state.paymentFailureMessage = error.response.data.errors[0];
    } else if (error?.response?.data?.message) {
      state.paymentFailureMessage = error.response.data.message;
    } else if (error?.message) {
      state.paymentFailureMessage = error.message;
    }
    state.showDonationFailureModal = true;
  }
};

const injectCheckoutLibrary = () => {
  const paymentLibraryScript = document.createElement("script");
  paymentLibraryScript.setAttribute(
    "src",
    `${process.env.VUE_APP_HYPERPAY_URL}/v1/paymentWidgets.js?checkoutId=${state.checkoutId}`
  );
  paymentLibraryScript.setAttribute(
    "integrity",
    getLocalValue("scriptIntegrity")
  );
  paymentLibraryScript.setAttribute("crossorigin", "anonymous");
  if (window.__nonce) {
    paymentLibraryScript.setAttribute("nonce-" + window.__nonce, "");
  }
  document.head.appendChild(paymentLibraryScript);

  state.isHyperpayInjected = true;
  setTimeout(() => {
    state.showApplepaySpinner = false;
  }, 300);

  if (state.cardType === "applepay") return;

  router.push(
    `/checkout?card_type=${state.cardType}&donation_amount=${state.donationModel.donation_amount}`
  );
   const queryParams = new URLSearchParams({
    card_type: state.cardType,
    donation_amount: state.donationModel.donation_amount,
  });

  if (state.isSehattyPage) {
    queryParams.append("sehatty", "true");
  }

  router.push(`/checkout?${queryParams.toString()}`);
};
const setDonationProgressData = (data, status) => {
  if (!data) return;
  state.progressDonationData = data;
  state.progressStatus = status;
  state.donationType = data.donation_info?.type;
  state.showInProgressModal = true;
};

const setDonationSuccessData = (data) => {
  if (!data) return;
  state.successDonationData = data?.donation_success_data;
  state.paymentSuccessMessage = data?.message;
  state.paymentSuccessHeading = data?.heading;
  state.donationType = data?.donation_success_data?.type;
  state.showDonationSuccessModal = true;
};

const checkPaymentStatus = async () => {
  try {
    const { data } = await DonationService.getPaymentStatusWithRetry(
      state.paymentTransactionId,
      state.resourcePath
    );
    if ((data.status === 202 || data.status ===400) && data.result) {
      setDonationProgressData(data.result, data.status);
    } else if (data.status === 200 && data.donation_success_data) {
      const successData = {
        donation_success_data: data.donation_success_data,
        message: data.message,
        heading: data.heading
      };
      setDonationSuccessData(successData);
    }
  } catch (error) {
    state.paymentFailureMessage = extractPaymentFailureMessage(error);
    if (error?.response?.data?.errors?.length > 0) {
      state.paymentFailureHeading = error.response.data.heading;
    }
    state.showDonationFailureModal = true;
  } finally {
    localStorage.removeItem("donationModel");
    localStorage.removeItem("wallet");
  }
};

const setDonationAmount = (amount) => {
  if (
    amount >
    state.caseDetails.required_amount - state.caseDetails.collected_amount
  ) {
    state.donationModel.donation_amount =
      state.caseDetails.required_amount - state.caseDetails.collected_amount;
  } else {
    state.donationModel.donation_amount = amount;
  }
};

const close =() =>
{
  state.showDonationSuccessModal = false;
  getCaseInfo();
}

const transfer = () => {
  const payload = {
    amount: state.donationModel.donation_amount,
    case_id: state.caseDetails.id,
  };
  MajorDonorsService.transferPayment(payload)
    .then((response) => {
      const info = response.data.result;
        state.successDonationData = {
        reference_number: info.receipt.reference_number,
        amount: info.receipt.donation_amount,
        date: info.receipt.donation_date,
        payment_method: info.receipt.donation_method,
        id: info.receipt.case_id,
        specialty: info.receipt.specialty,
      };
      state.paymentSuccessHeading= 'تمت عملية التبرع بنجاح';
      state.paymentSuccessMessage='شكراً لمساهمتك في شفاء، وأجزل الله لك المثوبة والعطاء ';
      state.donationType = DONATION_TYPE.MAJOR_DONOR;
      state.showDonationSuccessModal = true;
    })
    .catch((error) => {
      state.majorDonorFailureData = {
        message: error?.response?.data?.errors,
        reference_number: error?.response?.data?.result?.receipt?.reference_number,
        amount: error?.response?.data?.result?.receipt?.donation_amount,
        payment_method: error?.response?.data?.result?.receipt?.donation_method,
        specialty: error?.response?.data?.result?.receipt?.specialty,
        date: error?.response?.data?.result?.receipt?.donation_date,

      };
      state.showMajorDonorFailureModal = true;
    });
};

// Computed properties
const closedCasesCondition = computed(
  () =>
    state.donationClosed ||
    state.caseDetails?.is_completed ||
    state.caseDetails?.is_cancelled
);

const invalidOnBehalfName = computed(
  () =>
    !!state.donationModel.on_behalf_donation &&
    state.donationModel.on_behalf_donor_name?.length > 20
);

const disableSubmit = computed(
  () =>
    !state.donationModel.donation_amount ||
    (state.donationModel.doner_mobile &&
      !isValidMobileNumber(state.donationModel.doner_mobile)) ||
    state.loading || invalidAmount.value || invalidOnBehalfName.value
);

const maximumDonationAmount = computed(() =>
  Math.ceil(
    state.caseDetails.required_amount - state.caseDetails.collected_amount
  ).toLocaleString("en-US")
);
const minimumAmount = computed(() =>
  state.caseDetails?.remainingAmount > configMinimumAmount
    ? configMinimumAmount
    : state.caseDetails?.remainingAmount
);
const invalidAmount = computed(() => {
  return(
    ((!state.donationModel.donation_amount && state.isSubmitted) ||
    (state.donationModel.donation_amount < minimumAmount.value && state.donationModel.donation_amount))
);
});
const isAuthenticated = computed(() => store.getters.isAuthenticated)

// Initialize
getCaseInfo();

if (route.query.id && route.query.resourcePath) {
  state.resourcePath = route.query.resourcePath;
  state.paymentTransactionId = route.query.id;
  checkPaymentStatus();
}

// Watch
watch(
  () => route.params.case_id,
  () => {
    state.caseId = route.params.case_id;
    getCaseInfo();
  }
);
</script>

<style lang="scss" scoped>
@import "@/styles/components/donate";
@import "@/styles/components/riyal-logo";


@media (max-width: 900px) {
  .donate-button-spacer {
    display: none !important;
  }
}

.donate-back-button-wrapper {
  box-shadow: none;
  padding: 0;
  max-width: 612px;
}

.donate-button-spacer {
  box-shadow: none;
  max-width: 612px;
}

.donate-back-button {
  color: $color-complementary !important;
  border-color: $color-complementary !important;
  background: transparent !important;
  
  &:hover,
  &:focus {
    background: $color-white !important;
    box-shadow: none !important;
    color: $color-complementary !important;
    border-color: $color-complementary !important;
  }
}
</style>
